var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "created-box" }, [
    _c("div", { staticClass: "created" }, [
      _c("img", { attrs: { src: "/img/icons/128.png" } }),
      _vm._v(" " + _vm._s(_vm.$ct("common.created-by-winfakt")) + " "),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }